import { isLocalHost } from "../lib/env";
import type { SiteConfig } from "../lib/gboModels";
import { gboClient } from "../lib/gboApiClient";
import { readEmbeddedSiteConfig } from "../lib/siteConfigBootstrap";
import { siteConfigLoaded } from "../features/tenant/tenantSlice";
import { gboApi } from "./gboApiBase";

export type TenantQueryArg = {
  host?: string;
};

export const siteSessionApi = gboApi.injectEndpoints({
  endpoints: (builder) => ({
    getSiteConfig: builder.query<SiteConfig, TenantQueryArg>({
      queryFn: async ({ host }) => {
        const embedded = readEmbeddedSiteConfig();
        if (embedded) return { data: embedded };

        const selectedHost = isLocalHost() ? host : window.location.hostname;
        return gboClient.get<SiteConfig>(
          `site-config?host=${encodeURIComponent(selectedHost ?? "")}`,
          { tenantId: null },
        );
      },
      onQueryStarted: (_arg, { dispatch, queryFulfilled }) => {
        void queryFulfilled.then(
          ({ data }) => dispatch(siteConfigLoaded(data)),
          () => undefined,
        );
      },
      providesTags: ["SiteConfig"],
    }),
  }),
});

export const { useGetSiteConfigQuery } = siteSessionApi;
